import { Add, InfoCircleLine, LayersFront } from '@factorialco/factorial-one-react/icons/app'
import { BankAccountRoutesBankAccountFragment } from 'generated/resources/graphql'

import { dateBackendDateTimeToRelativeTime } from 'modules/core/lib/dates'
import formatCurrency from 'modules/core/lib/formatCurrency'
import i18n from 'modules/core/lib/i18n'
import { ResourceHeadersPropsWithoutActions } from 'modules/core/lib/navigation/types'

export const buildBankAccountHeaderComponentProps = (
  canSeeAccountPage: boolean,
  bankAccount?: BankAccountRoutesBankAccountFragment | null
): ResourceHeadersPropsWithoutActions => {
  if (!bankAccount || !canSeeAccountPage) {
    return {
      title: '',
    }
  }

  const title = bankAccount.accountAlias ?? bankAccount.accountNumber.slice(-4)
  const institution = bankAccount.account.institution
  const account = bankAccount.account
  const configuration = account.providerConfiguration
  const addFundsAvailable = !configuration?.services.includes('import_data')

  const formattedBankAccountNumber =
    bankAccount.accountNumberType === 'iban'
      ? (bankAccount.iban || '').split(/(.{4})/).join(' ')
      : bankAccount.accountNumber

  const showDetailAction = {
    key: 'show_detail',
    icon: InfoCircleLine,
    label: i18n.t('common.details'),
  }
  const showAddFundsAction = {
    key: 'show_add_funds',
    icon: Add,
    label: i18n.t('banking.accounts.actions.add_money'),
  }
  const actions = addFundsAvailable ? [showDetailAction, showAddFundsAction] : [showDetailAction]

  return {
    title: formatCurrency(bankAccount.availableBalanceCents),
    avatar: institution
      ? {
          src: institution.logo,
          firstName: institution.name,
          lastName: '',
          type: 'person',
        }
      : {
          name: title,
          type: 'team',
        },
    metadata: [
      {
        label: 'IBAN',
        value: {
          content: formattedBankAccountNumber,
          type: 'text',
        },
        actions: [
          {
            icon: LayersFront,
            label: i18n.t('common.copy'),
            onClick: () =>
              navigator.clipboard.writeText(bankAccount.iban ?? bankAccount.accountNumber),
          },
        ],
      },
    ],
    description: title,
    status: {
      label: 'Sync',
      text: i18n.t('banking.accounts.last_sync_at', {
        relative_time: dateBackendDateTimeToRelativeTime(bankAccount.lastSynchronisedAt),
      }),
      variant: 'neutral',
    },
    primaryAction: {
      icon: LayersFront,
      label: i18n.t('common.copy'),
    },
    secondaryActions: actions,
    otherActions: actions,
  }
}
